import React, { useEffect } from 'react';
import JunoClientSnackbar from '../../client/Juno/client/components/global/JunoClientSnackbar';
import FiatDashboardPage from './FiatDashboardPage';
import CryptoDashboardPage from './CryptoDashboardPage';
import { useJunoCommonFunctions } from '../../client/Juno/helpers';
import { useSelector } from 'react-redux';
import VerifyClientDetailsCard from '../../client/Juno/JunoMoney/components/register/VerifyClientDetailsCard';

const JncOverviewPage = () => {
    const {
        getBalances,
        getCryptoBalances,
        getManagedCurrencies,
    } = useJunoCommonFunctions();
    const activeCurrencyPage = useSelector(state => state.juno.activeCurrencyPage);
    const clientData = useSelector(state => state.juno.clientData);
    const userRegistrationState = useSelector(
        state => state.juno.clientData?.userRegistrationState,
    );
    useEffect(() => {
        if (clientData) {
            if (activeCurrencyPage === 'crypto') {
                getCryptoBalances();
            }
            getBalances();
            getManagedCurrencies(clientData?.clientId);
        }
    }, [clientData, activeCurrencyPage]);

    const isBusinessAccountComplete =
        clientData?.accountType === 'Business' &&
        userRegistrationState?.uploadDocuments &&
        userRegistrationState?.accountPurpose &&
        userRegistrationState?.transactionActivity;

    const isPersonalAccountComplete =
        clientData?.accountType === 'Personal' &&
        userRegistrationState?.accountPurpose &&
        userRegistrationState?.transactionActivity;

    const shouldShowVerifyCard = !(
        isBusinessAccountComplete ||
        isPersonalAccountComplete ||
        clientData?.onboardingStatus === 'Approved'
    );

    return (
        <>
            {activeCurrencyPage === 'fiat' ? (
                <div>
                    <div className="bg-[#18181B]">
                        {shouldShowVerifyCard && <VerifyClientDetailsCard />}
                    </div>
                    <FiatDashboardPage />
                </div>
            ) : (
                <CryptoDashboardPage />
            )}
            <JunoClientSnackbar />
        </>
    );
};

export default JncOverviewPage;
